export default __webpack_public_path__ + "static/media/BG.9386fcbf.svg";